export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

export const USER_SIGNUP_REQUEST = 'USER_SIGNUP_REQUEST';
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS';
export const USER_SIGNUP_FAIL = 'USER_SIGNUP_FAIL';

export const WISHLIST_REQUEST = 'WISHLIST_REQUEST';
export const WISHLIST_SUCCESS = 'WISHLIST_SUCCESS';
export const WISHLIST_FAIL = 'WISHLIST_FAIL';

export const WISHLIST_ADD_PRODUCT_REQUEST = 'WISHLIST_ADD_PRODUCT_REQUEST';
export const WISHLIST_ADD_PRODUCT_SUCCESS = 'WISHLIST_ADD_PRODUCT_SUCCESS';
export const WISHLIST_ADD_PRODUCT_FAIL = 'WISHLIST_ADD_PRODUCT_FAIL';

export const WISHLIST_REMOVE_PRODUCT_REQUEST =
  'WISHLIST_REMOVE_PRODUCT_REQUEST';
export const WISHLIST_REMOVE_PRODUCT_SUCCESS =
  'WISHLIST_REMOVE_PRODUCT_SUCCESS';
export const WISHLIST_REMOVE_PRODUCT_FAIL = 'WISHLIST_REMOVE_PRODUCT_FAIL';

export const CART_REQUEST = 'CART_REQUEST';
export const CART_SUCCESS = 'CART_SUCCESS';
export const CART_FAIL = 'CART_FAIL';

export const CART_ADD_PRODUCT_REQUEST = 'CART_ADD_PRODUCT_REQUEST';
export const CART_ADD_PRODUCT_SUCCESS = 'CART_ADD_PRODUCT_SUCCESS';
export const CART_ADD_PRODUCT_FAIL = 'CART_ADD_PRODUCT_FAIL';

export const CART_REMOVE_PRODUCT_REQUEST = 'CART_REMOVE_PRODUCT_REQUEST';
export const CART_REMOVE_PRODUCT_SUCCESS = 'CART_REMOVE_PRODUCT_SUCCESS';
export const CART_REMOVE_PRODUCT_FAIL = 'CART_REMOVE_PRODUCT_FAIL';

export const CART_UPDATE_PRODUCT_REQUEST = 'CART_UPDATE_PRODUCT_REQUEST';
export const CART_UPDATE_PRODUCT_SUCCESS = 'CART_UPDATE_PRODUCT_SUCCESS';
export const CART_UPDATE_PRODUCT_FAIL = 'CART_UPDATE_PRODUCT_FAIL';

export const GET_ADDRESS_REQUEST = 'GET_ADDRESS_REQUEST';
export const GET_ADDRESS_SUCCESS = 'GET_ADDRESS_SUCCESS';
export const GET_ADDRESS_FAIL = 'GET_ADDRESS_FAIL';

export const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const ADD_ADDRESS_FAIL = 'ADD_ADDRESS_FAIL';

export const REMOVE_ADDRESS_REQUEST = 'REMOVE_ADDRESS_REQUEST';
export const REMOVE_ADDRESS_SUCCESS = 'REMOVE_ADDRESS_SUCCESS';
export const REMOVE_ADDRESS_FAIL = 'REMOVE_ADDRESS_FAIL';

export const UPDATE_ADDRESS_REQUEST = 'UPDATE_ADDRESS_REQUEST';
export const UPDATE_ADDRESS_SUCCESS = 'UPDATE_ADDRESS_SUCCESS';
export const UPDATE_ADDRESS_FAIL = 'UPDATE_ADDRESS_FAIL';

export const ORDERS_REQUEST = 'ORDERS_REQUEST';
export const ORDERS_SUCCESS = 'ORDERS_SUCCESS';
export const ORDERS_FAIL = 'ORDERS_FAIL';

export const PLACE_ORDER_REQUEST = 'PLACE_ORDER_REQUEST';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_FAIL = 'PLACE_ORDER_FAIL';

export const ORDER_DETAILS_REQUEST = 'ORDER_DETAILS_REQUEST';
export const ORDER_DETAILS_SUCCESS = 'ORDER_DETAILS_SUCCESS';
export const ORDER_DETAILS_FAIL = 'ORDER_DETAILS_FAIL';
